import React, { useMemo } from 'react';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';

// Helpers
const toISO = (d) => {
  if (!d || Number.isNaN(d.getTime())) return '';
  // Keep local date, no timezone shift in the string
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  return `${y}-${m}-${day}`;
};
const fromISO = (s) => {
  if (!s) return null;
  const [y, m, d] = s.split('-').map(Number);
  if (!y || !m || !d) return null;
  // local date object at local midnight
  return new Date(y, m - 1, d);
};

export default function IsoDatePicker({
  value,                // 'YYYY-MM-DD' | ''
  onChange,             // (isoString) => void
  placeholderText = 'Select date',
  minDate,              // 'YYYY-MM-DD'
  maxDate,              // 'YYYY-MM-DD'
  disabledDates = [],   // array<'YYYY-MM-DD'>
  className = 'w-full',
  isClearable = true,
  includeDates = [],
  includeDatesStrict = false,
  disableManual = true,
  disabled = false,
}) {
  const selected = useMemo(() => fromISO(value || ''), [value]);
  const minD = useMemo(() => fromISO(minDate || ''), [minDate]);
  const maxD = useMemo(() => fromISO(maxDate || ''), [maxDate]);
  const excludeDates = useMemo(() => (disabledDates || []).map(fromISO).filter(Boolean), [disabledDates]);
  const includeDatesObjs = useMemo(() => (includeDates || []).map(fromISO).filter(Boolean), [includeDates]);
  const openTo = useMemo(() => {
    if (selected) return selected;
    if (includeDatesObjs.length) return includeDatesObjs[0];
    if (minD) return minD;
    return undefined;
  }, [selected, includeDatesObjs, minD]);
  return (
    <div className={className}>
      <DatePicker
        selected={selected}
        onChange={(d) => onChange?.(toISO(d))}
        onChangeRaw={disableManual ? (e) => e.preventDefault() : undefined}
        placeholderText={placeholderText}
        minDate={minD || undefined}
        maxDate={maxD || undefined}
        excludeDates={excludeDates}
        dateFormat="yyyy-MM-dd"
        isClearable={!disabled && isClearable}
        className="border rounded px-2 py-1 w-full"
        includeDates={includeDatesStrict ? includeDatesObjs : (includeDatesObjs.length ? includeDatesObjs : undefined)}
        openToDate={openTo}
        showPopperArrow={false}
        showDisabledMonthNavigation
        fixedHeight
        disabled={disabled}
      />
    </div>
  );
}
